export function addedClasses(options = {}) {
  return (tree: any, file: any) => {
    function parse(tree: any) {
      for (const key in tree.children) {
        if (tree.children.hasOwnProperty(key)) {
          const element = tree.children[key];
          if (element.type === 'text' && element.value.startsWith('{.')) {
            const closedIndex = element.value.indexOf('}');
            const prev = tree.children[parseInt(key) - 1];
            if (prev && closedIndex !== -1) {
              prev.properties.class = element.value.slice(2, closedIndex);
              element.value = element.value.slice(closedIndex + 1);
            }
          }
          if (element.children && element.children.length > 0) {
            parse(element);
          }
        }
      }
    }

    return parse(tree)
  }
}
